import React from 'react';
import IMenuItem from '../interfaces/IMenuItem';
// import '../css/fichecontact.scss';

// const Menu = (items: IMenuItem) => (
//     <div>
//         <p>{items.title}</p>
//     </div>
// );
const Menu: React.FC<{ items: IMenuItem[] }> = ({ items }) => {
    return (
        <ul>
            {items.map((item, index) => (
                <li key={index}>
                    <a href={item.url}>{item.title}</a>
                    {/* Commentaires : si on veut plus de 2 niveaux */}
                    {/* <div className="subMenu">{item.subMenu && <Menu items={item.subMenu} />}</div> */}
                </li>
            ))}
        </ul>
    );
};

export default Menu;